var _circle, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRetry = function SvgRetry(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 24.3197C11.3922 24.3197 7.68018 20.6077 7.68018 15.9997C7.68018 11.3917 11.3922 7.67969 16.0002 7.67969C19.4562 7.67969 22.4642 9.85569 23.6162 13.2477L22.4002 13.6957C21.4402 10.7517 18.9442 8.95969 16.0002 8.95969C12.0962 8.95969 8.96018 12.0957 8.96018 15.9997C8.96018 19.9037 12.0962 23.0397 16.0002 23.0397C18.7522 23.0397 21.2482 21.4397 22.4002 18.9437L23.5522 19.4557C22.2082 22.3997 19.2642 24.3197 16.0002 24.3197Z",
    fill: "#227EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3202 14.08H19.2002V12.8H23.0402V8.95996H24.3202V14.08Z",
    fill: "#227EFF"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRetry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retry.b67f9c61.svg";
export { ForwardRef as ReactComponent };